import { render, staticRenderFns } from "./CAxACGxLanguagePage.vue?vue&type=template&id=67f9b616"
import script from "./CAxACGxLanguagePage.vue?vue&type=script&lang=js"
export * from "./CAxACGxLanguagePage.vue?vue&type=script&lang=js"
import style0 from "./CAxACGxLanguagePage.vue?vue&type=style&index=0&id=67f9b616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports